import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
} from '@angular/core';
import { BaseComponent } from '@macs-frontend/core';
import { makeSelectable, SelectSubscribe } from '@macs-frontend/decorators';
import { Store } from '@ngrx/store';
import * as fromRoot from '@macs-frontend/reducers';

@Component({
  selector: 'md-wrap-loader',
  templateUrl: 'wrap-loader.component.html',
  styleUrls: ['wrap-loader.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WrapLoaderComponent extends BaseComponent {
  @SelectSubscribe(fromRoot.loaderInProgressSelector)
  loaderInProgress: string[] = [];

  @Input() actions: null | string | string[] = null;

  @Input() show: boolean | null = null;

  @Input() hideContent = false;

  constructor(readonly cdr: ChangeDetectorRef, readonly store$: Store) {
    super();
    makeSelectable(this, { cdr, store$ });
  }

  showLoader() {
    if (this.show !== null) {
      return this.show;
    }

    if (this.actions === null) {
      return true;
    }
    const actions = Array.isArray(this.actions) ? this.actions : [this.actions];
    return actions.some(type => this.loaderInProgress.includes(type));
  }

  getBackgroundColor() {
    return this.hideContent ? 'rgba(255, 255, 255, 1)' : 'rgba(255, 255, 255, 0.5)';
  }
}
